export default __webpack_public_path__ + "static/media/blog_inner_18.b74d0189.jpg";